import styled from 'styled-components';
import Card from 'semantic-ui-react/dist/commonjs/views/Card';
import Branding from '../uielements/Branding';
import devices from '../../common/styles/devices';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

const AcknowledgeCardWrapper = styled(Card)`
  &&& {
    width: 70%;
    padding: 50px 0;
    border-radius: 15px;
    box-shadow: 0 3px 18px 0 rgba(0, 0, 0, 0.1);
    border: solid 1.3px #bfe9f7;
    display: flex;
    align-items: center;
    margin: 40px auto;
  }

  @media ${devices.mobileL} {
    &&& {
      width: 90%;
      padding: 50px 40px;
      margin: 30px auto;
    }
  }

  @media ${devices.mobileS} {
    &&& {
      padding: 50px 10px;
    }
  }
`;

const AcknowledgeCardIcon = styled('img')`
  width: 70px;
  height: 70px;
  margin-bottom: 20px;

  @media ${devices.mobileL} {
    margin-bottom: 40px;
  }
`;

const AcknowledgeCardHeader = styled('h1')`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 36px;
  font-weight: 900;
  color: ${COLORS.black};
  margin-top: 20px;

  @media ${devices.mobileL} {
    margin-bottom: 20px;
  }
`;

const AcknowledgeCardDescription = styled(Branding)`
  &&& {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 20px;
    font-weight: 500;
    line-height: 2.4;
    color: ${COLORS.textLightGrey};
    margin-top: 20px;

    @media ${devices.mobileS} {
      font-size: 18px;
      font-weight: 500;
      line-height: 1.67;
    }

    @media ${devices.mobileL} {
      margin-bottom: 30px;
      font-size: 20px;
      line-height: 1.5;
      width: 270px;
    }
  }
`;

const AcknowledgeCardBranding = styled(Branding)`
  &&& {
    font-family: 'hellix-regular';
    font-size: 20px;
    font-weight: 900;
    line-height: 2.1;
    color: ${COLORS.black};
    margin-top: 25px;
  }

  @media ${devices.mobileS} {
    &&& {
      font-size: 18px;
    }
  }

  @media ${devices.mobileL} {
    &&& {
      margin-top: 0;
      font-size: 20px;
      line-height: 1;
      width: 250px;
    }
  }
`;

export {
  AcknowledgeCardWrapper,
  AcknowledgeCardIcon,
  AcknowledgeCardHeader,
  AcknowledgeCardDescription,
  AcknowledgeCardBranding
};
